import {
    GET_BATCH_EXPORT_REQUEST,
    GET_BATCH_EXPORT_SUCCESS,
    GET_BATCH_EXPORT_FAILURE,
    CLEAR_BATCH_EXPORT,
} from 'src/common/redux/actions/constants';

const initialState = {
    isLoading: false,
    isSuccess: false,
    error: null,
    fileName: null,
};

const batchExportReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_BATCH_EXPORT_REQUEST:
            return {
                ...state,
                isLoading: true,
                isSuccess: false,
                error: null,
            };
        case GET_BATCH_EXPORT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSuccess: true,
                fileName: action.payload?.fileName || null,
                error: null,
            };
        case GET_BATCH_EXPORT_FAILURE:
            return {
                ...state,
                isLoading: false,
                isSuccess: false,
                error: action.payload?.error || 'Export failed',
            };
        case CLEAR_BATCH_EXPORT:
            return initialState;
        default:
            return state;
    }
};

export default batchExportReducer;
